<app-template-priority-opp
    [lengthByScreen]="lengthByScreen"
></app-template-priority-opp>

<app-template-priority-templates
    [lengthByScreen]="lengthByScreen"
></app-template-priority-templates>

<!-- Save Modal -->
<app-confirm-modal [requirePassword]="true" [message]="saveModalMessage" [openModal]="openSaveModal" (outcome)="handleSaveModalOutcome($event)"/>
<!-- Export Modal -->
<app-confirm-modal [requirePassword]="false" [message]="exportModalMessage" [openModal]="openExportModal" (outcome)="handleExportModalOutcome($event)"/>
